import React from "react";
import { StyleSheet, View } from "react-native";

import { colors } from "../../../styles/design-system";

interface GapAnalysisVerticalLayoutProps {
  children: React.ReactNode;
  width?: number;
  height?: number;
}

function GapAnalysisVerticalLayout({ children, width = 540, height = 840 }: GapAnalysisVerticalLayoutProps) {
  return (
    <View style={[styles.drawerShell, { width, height }]}>
      <View style={styles.contentInset}>
        <View style={styles.contentCard}>{children}</View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  drawerShell: {
    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: colors.grey[200],
    borderRadius: 8,
    overflow: "hidden",
  },
  contentInset: {
    flex: 1,
    minHeight: 0,
    paddingTop: 48,
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
  contentCard: {
    flex: 1,
    minHeight: 0,
    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: colors.grey[200],
    borderRadius: 8,
    overflow: "hidden",
  },
});

export default GapAnalysisVerticalLayout;
